export default {
  documents: {},
  notifications: { data: [] },
  plan: {},
  links: {},
  dashboardDetails: [],
  pagination: {},
};
